<template>
  <div id="app">
    <div class="route-content" :style="{height:$route.meta.showTabbar?'calc(100vh - 3.5rem)': '100vh'}" style="height:calc(100vh - 3.5rem)">
      <keep-alive>
          <router-view v-if="$route.meta.isKeep" />
      </keep-alive>
      <router-view v-if="!$route.meta.isKeep" />
    </div> 
    <tabbar v-if="$route.meta.showTabbar"></tabbar>
  </div>
</template>

<script>
import store from './store'
import tabbar from './components/tabbar.vue'
export default {
  name: 'App',
  components: {
    tabbar,
  },
  created() {
    console.log(this.$route,'route')
    store.dispatch('GetGlobalInfo')
  },
  
}
</script>

<style lang="scss">
@import './assets/css/reset.css';	
#app {
  font-family:'Microsoft Yahei', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100vw;
  height: 100vh;
  .xw-page{
    width: 100%;
    height: 100%;
    position: relative;
  }
}
.route-content{
  height: calc(100vh - 1.2rem);
}
.loading{
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 0.24rem;
	span{
		margin-left: 2%;
		color: #666;
	}
}

.no-data{
  width: 60%;
  margin: 0 20%;
  padding-top: 80px;
  .n-d-i{
    width: 100%;
  }
  .n-t{
    text-align: center;
    margin-top: 10px;
    font-size: 24px;
    color: grey;
  }
}
</style>

